import React, { useState, useRef, useEffect } from 'react';
import MenuOpciones from '../globales/MenuOpciones';
import useIsMobile from '../../utilities/function/useIsMobile';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Keyboard, Lazy, Navigation } from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
SwiperCore.use([Navigation, Keyboard, Lazy]);


const MenuLateral = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [anchoMenu, setAnchoMenu] = useState('');
  const refMenu = useRef(null);
  const isMobile = useIsMobile();
  const menu = MenuOpciones();

  useEffect(() => {
    if (!!refMenu.current) {
      calcularAncho();
      window.addEventListener('resize', calcularAncho);
      return () => {
        window.removeEventListener('resize', calcularAncho);
      }
    }
  }, [refMenu]);

  const calcularAncho = () => {
    const valorAncho = refMenu.current.clientWidth;
    setAnchoMenu(valorAncho);
  }

  return (

    <>
    
      <div style={{ right: isOpen ? 0 : -anchoMenu }}
        className={isMobile ?  'hidden' : 'fixed flex transition-all duration-500  bg-no-repeat img-cover-center items-start z-50 h-screen mt-28'}
      >
        <button
          onClick={() => { setIsOpen(!isOpen) }}
          className=" w-52 bg-verde  py-2 px-5 text-blanco poppins-700 rounded-t-22 transform -rotate-90 origin-bottom-right -mt-10"
        >
          <span className="icon-mas"></span> Elige otra historia
        </button>

        <div className="flex-auto bg-verde px-5 py-3 rounded-b-22 " ref={refMenu}>
          <Swiper
            direction={"vertical"}
            slidesPerView={3}
            navigation={true}
            spaceBetween={10}
            keyboard={true}
            className="  overflow-hidden relative contenedor-swiper"
            style={{ height: '655px' }}
          >
            {menu.map((item, index) =>
              <SwiperSlide
                key={index}
                className="img-contain-center  flex items-end bg-blanco hover:bg-verde-portada shadow"
                style={{
                  backgroundImage: 'url(' + require(`../../images/fondos-menu/menu${index}.png`).default + ')'
                }}
              >
                <Link to={item.link}>
                <div className="px-5 pb-5 pt-7 w-56 mt-16 ">
                  <div>
                    <p className={`poppins-700 text-14 pb-3`}>{item.titulo}</p>
                    <hr className=" border-negro" />
                    <p className="poppins-300 py-3 text-13">{item.ciudad} - {item.departamento} </p>
                  </div>
                </div>
                </Link>
              </SwiperSlide>


            )}

          </Swiper>
        </div>
      </div>
    </>
  )
}

export default MenuLateral;

